import ReqClient from './request.class'

// 获取规则详情
export async function getCalculatorPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/payback/calc/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getCalculatorDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/payback/calc/queryDetail',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function delCalculatorById(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/payback/calc/del',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function addCalculator(data) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/payback/calc/addOrUpdate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 导入计算器
export async function importCalcPayBackExcel(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/payback/calc/import',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getPerformancePage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/findDesignerKipByPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getPerformanceDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/findDesignerKipById',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function delPerformanceById(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/deleteDesignerKipInfo',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function addPerformance(data) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/addDesignerKip',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function editPerformance(data) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/updateDesignerKip',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function savePerformance(data) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/updateDesignerKip',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 导入设计KPI
export async function importPerformanceExcel(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/kpi/importDesignerKip',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 设计个人数据
 * @param {*} params
 */
export async function getPlannerPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/findMaterialDataByPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 涉及个人数据（新）
 * @param {*} params
 */
export async function getNewDesignerPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/findMaterialDataNewByPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function asynPlannerPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/materialData/retryTask',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getWorkPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/imageData',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 机器人归因列表查询
export async function getPlanDataPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/AI/PlanDataPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 设计个人数据导出
 * @param {*} data
 * @return {*}
 */
export async function exportDesignerPersonalTableData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/materialDataExportNew',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
